import { render, staticRenderFns } from "./VistaPadreGestionCatequesis.vue?vue&type=template&id=77c55bc7&"
import script from "./VistaPadreGestionCatequesis.vue?vue&type=script&lang=js&"
export * from "./VistaPadreGestionCatequesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports